import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class OrganizationUnitAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'organizationunit';
}

export default new OrganizationUnitAPI();
